import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { AppendToBodyModule } from 'Angular/features/directives/append-to-body/append-to-body.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';

import { SingleSelectDropdownComponent } from './single-select-dropdown.component';

@NgModule({
    imports: [CommonModule, DisabledModule, FeatureNeededModule, FormsModule, HelpModalModule, AppendToBodyModule],
    declarations: [SingleSelectDropdownComponent],
    exports: [SingleSelectDropdownComponent],
})
export class SingleSelectDropdownModule {}
